import { t } from "@bookingcom/lingojs-react";
import useRouteName from "../../hooks/useRouteName";
import { useSelector } from "react-redux";
import { getSearch } from "../../store/search/selectors";
import { getFlight } from "../../store/flightDetails/selectors";

export const useGetFareFeaturesSubtitleCopy = () => {
  const search = useSelector(getSearch);
  const flight = useSelector(getFlight);
  const routeName = useRouteName();
  const isCheckAndPay = routeName === "checkout-payment";

  const totalTravellersOnSearch = (search.adults || 0) + (search.children || []).length;
  const totalTravellersOnFunnel = (flight?.travellers && flight?.travellers?.length) || 0;
  const hasMultipleTravellers = totalTravellersOnSearch > 1 || totalTravellersOnFunnel > 1;
  const baseCopy = isCheckAndPay ? t("flights_pb_fare_subheader") : t("flight_fare_included");

  const headerCopy = hasMultipleTravellers ? t("flights_bf_included_each") : baseCopy;

  return {
    headerCopy,
    hasMultipleTravellers
  };
};
